module.exports = __webpack_public_path__ + "static/media/galleryGT (16).49ebc40e.jpg";